<template lang="pug">
div
  component(
    v-for="drawer in drawers"
    :is="drawer.component"
    v-bind="extendAttrs(drawer)"
    v-on="extendListeners(drawer)"
    :value="drawer.state"
    :key="drawer.id"
  )
</template>

<script>
export default {
  data() {
    return {
      drawers: [],
    };
  },
  created() {
    this.$drawers.resetAll();
  },
  mounted() {
    this.drawers = this.$drawers.list();
  },
  methods: {
    extendAttrs(drawer) {
      return { ...drawer.attrs };
    },
    extendListeners(drawer) {
      const { removeDialog } = this;
      const isPersistent = drawer.attrs?.persistent || false;
      return {
        ...drawer.listeners,
        close: () => {
          if (!isPersistent) removeDialog(drawer.id);
          // eslint-disable-next-line
          drawer.listeners?.close?.();
        },
      };
    },
    removeDialog(id) {
      const { $drawers } = this;

      $drawers.remove(id);
      this.drawers = $drawers.list();
    },
  },
};
</script>
